export const CHECKBOX = 'checkbox';

export const DROPDOWN = 'dropdown';

export const PAYMENT_STATUS_ITEMS = {
  SUCCESS: 'Success',
  PENDING: 'Pending',
  FAILED: 'Failed',
  USER_DROPPED: 'User Dropped',
  VOID: 'Void',
  INCOMPLETE: 'Incomplete',
  CANCELLED: 'Cancelled',
};

export const CAPTURE_STATUS_ITEMS = {
  NOT_CAPTURED: 'Not Captured',
  CAPTURED: 'Captured',
};

export const CAPTURE_STATUS_FILTERS = {
  displayText: 'Capture Status',
  type: CHECKBOX,
  items: CAPTURE_STATUS_ITEMS,
};

export const PAYMENT_METHODS_ITEMS = {};

export const PAYMENT_METHODS_FILTERS = {
  displayText: 'Payment Methods',
  type: CHECKBOX,
  items: PAYMENT_METHODS_ITEMS,
};

export const PAYMENT_VERIFICATION_ITEMS = {
  ACTION_REQUIRED: 'Action Required',
  IN_REVIEW: 'In Review',
  VERIFIED: 'Verified',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled',
  SKIPPED: 'Verification Skipped',
};

export const PAYMENT_VERIFICATION_FILTER = {
  displayText: 'Payment Verification Status',
  type: CHECKBOX,
  items: PAYMENT_VERIFICATION_ITEMS,
};

export const ORDER_AMOUNT_FILTER_OPTIONS = [
  {
    key: 'IS_LESS_THAN_EQUAL_TO',
    value: 'IS_LESS_THAN_EQUAL_TO',
    text: 'is less than equal to',
  },
  { key: 'IS_BETWEEN', value: 'IS_BETWEEN', text: 'is between' },
  { key: 'IS_EQUAL_TO', value: 'IS_EQUAL_TO', text: 'is equal to' },
  {
    key: 'IS_GREATER_THAN_EQUAL_TO',
    value: 'IS_GREATER_THAN_EQUAL_TO',
    text: 'is greater than equal to',
  },
];

export const ORDER_AMOUNT_FILTER = {
  displayText: 'Net Settled Amount',
  type: DROPDOWN,
  items: ORDER_AMOUNT_FILTER_OPTIONS,
};

export const ORDER_TYPE_ITEMS = {
  PRODUCT: 'Product Link',
  POS: 'POS',
  PG: 'Payment Gateway',
  CFID: 'Payme Link',
  SBC: 'Subscription',
  API: 'Payment Gateway API',
};

export const ORDER_TYPE_ITEMS_IMPORTS = {
  PRODUCT: 'Product Link',
  PG: 'Payment Gateway',
  SBC: 'Subscription',
  API: 'Payment Gateway API',
};

export const SDK_ITEMS = {
  'app-sdk': 'Android',
  'react-native-android': 'Android React Native',
  'flutter-android': 'Android Flutter',
  reactsdk: 'Android React',
  'sdk-transparent': 'Transparent',
  'capacitor-android': 'Android Capacitor',
  iossdk: 'IOS',
  'custom-mob-sdk': 'Mobile',
  'cordova-android': 'Android Cordova',
  'react-native-ios-sdk': 'IOS React Native',
  'sdk-js': 'JS',
  'flutter-ios-sdk': 'IOS Flutter',
  'nextgenapi-js': 'JS Nextgen',
  'nextgenapi-android': 'Android Nextgen',
  'nextgenapi-ios': 'IOS Nextgen',
  'flutter-sdk': 'Flutter',
  'capacitor-ios-sdk': 'IOS Capacitor',
  'xamarin-ios-sdk': 'IOS Xamarin',
  'cordova-ios-sdk': 'IOS Cordova',
  'xamarin-android': 'Android Xamarin',
  'xamarin-forms': 'Form Xamarin',
  'cordova-sdk': 'Cordova',
};

export const API_ITEMS = {
  api: 'API',
  'seamless-pro': 'Seamless',
  nextgenapi: 'API Nextgen',
};

export const CHECKOUT_ITEMS = {
  'checkout-form': 'Checkout Form',
  shopify: 'Shopify',
  opencart: 'Opencart',
  woocommerce: 'Woocommerce',
  cscart: 'Cscart',
  whmcs: 'Whmcs',
  magento: 'Magneto',
};

const ORDER_SOURCE_BASE = {
  SDK: {
    key: 'orderSource',
    displayText: 'SDK',
    type: CHECKBOX,
    placeholder: 'Search SDK',
    items: SDK_ITEMS,
  },
  API: {
    key: 'orderSource',
    displayText: 'API',
    type: CHECKBOX,
    placeholder: 'Search API',
    items: API_ITEMS,
  },
  CHECKOUT: {
    key: 'orderSource',
    displayText: 'Checkout',
    type: CHECKBOX,
    placeholder: 'Search Checkout',
    items: CHECKOUT_ITEMS,
  },
};

export const ORDER_SOURCE_ITEMS_IMPORT = { ...ORDER_SOURCE_BASE };

export const ORDER_SOURCE_ITEMS = {
  // OCC: 'One Click Checkout',
  ...ORDER_SOURCE_BASE,
  softpos: 'softPOS',
};

export const ORDER_STATUS_ITEMS = {
  PAID: 'Paid',
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
};

export const BATCH_CAPTURE = 'Batch Capture';

export const INITIATED_REFUNDS = 'Initiated Refunds';

export const BATCH_REFUNDS = 'Batch Refunds';

export const AUTO_REFUNDS = 'Auto Refunds';

export const STANDARD = 'Standard';

export const INSTANT = 'Instant';

export const VENDOR = 'Vendor';

export const ACTION_REQUIRED = 'Action Required';

export const UNDER_REVIEW = 'Under Review';

export const CLOSED = 'Closed';

export const VERIFIED = 'Verified';

export const EXPIRED = 'Expired';

export const ALL = 'All';

export const SETTLEMENTS_STATUS_ITEMS = [
  {
    key: 'PROCESSED',
    value: 'PROCESSED',
    text: 'Processed',
  },
  {
    key: 'FAILED',
    value: 'FAILED',
    text: 'Failed',
  },
  {
    key: 'PENDING',
    value: 'PENDING',
    text: 'In Progress',
  },
];

export const SETTLEMENTS_TYPE_ITEMS = {
  NORMAL_SETTLEMENT: 'Standard',
  INSTANT_SETTLEMENT: 'Instant',
};

export const SETTLEMENTS_STATUS_IMPORT_ITEMS = [
  {
    key: 'PROCESSED',
    value: 'SETTLED',
    text: 'Processed',
  },
  {
    key: 'INITIATED',
    value: 'NOT_INITIATED,INITIATED,PENDING',
    text: 'In Progress',
  },
  {
    key: 'SKIPPED',
    value: 'SKIPPED',
    text: 'Skipped',
  },
  {
    key: 'REVERSED',
    value: 'REVERSED',
    text: 'Failed',
  },
];

export const INTEGRATION_TYPE_ITEMS = {
  displayText: 'Integration Type',
  type: CHECKBOX,
  items: { OCC: 'One Click Checkout' },
};

export const PAYMENT_OFFER_APPLIED_ITEMS = {
  displayText: 'Offer Status',
  type: CHECKBOX,
  items: {
    APPLIED: 'Offer Applied',
    NOT_APPLIED: 'Offer Not Applied',
  },
};
